import Templates from 'pages/templates/Templates'
import Profile from 'pages/patient/householdModal/Profile'
import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ReferralSpecialities from 'pages/settings/components/ReferralSpecialities'
import { path } from 'utils/const'
const Dashboard = lazy(() => import('pages/dashboard'))
const Patient = lazy(() => import('pages/patient'))
const LabTracking = lazy(() => import('pages/lab-tracking'))
const MedicalNoteTracking = lazy(() => import('pages/medical-note'))
const LabSupport = lazy(() => import('pages/lab-support'))
const PhysioPanel = lazy(() => import('pages/physio-panel'))
const PhysioPipeline = lazy(() => import('pages/physio-submissions'))
// const Settings = lazy(() => import('pages/settings'))

const PrescriptionTracking = lazy(() => import('pages/prescription-tracking'))
const Logs = lazy(() => import('pages/PatientLogs/Logs'))
const MedicalTab = lazy(() => import('pages/medical-tab/medicalTab'))
const MedicalNotesTab = lazy(() => import('pages/medical-notes-tab/MedicalNotesTab'))
export const doctorRoutes = [
  {
    path: '/dashboard',
    index: true,
    element: <Dashboard />,
  },
  {
    path: '/patient',
    element: <Patient />,
  },
  {
    path: '/prescription-tracking',
    element: <PrescriptionTracking />,
  },
  {
    path: '/lab-tracking',
    element: <LabTracking />,
  },
  {
    path: '/medical-note',
    element: <MedicalNoteTracking />,
  },
  {
    path: '/physio-panel',
    element: <PhysioPanel />,
  },
  {
    path: '/physio-submissions',
    element: <PhysioPipeline />,
  },
  {
    path: '/lab-support',
    element: <LabSupport />,
  },
  {
    path: '/templates',
    element: <Templates />,
  },
  {
    path: '/referral-specialities',
    element: <ReferralSpecialities />,
  },
  {
    path: '/medical-tab/:patientId',
    element: <MedicalTab />,
  },
  {
    path: '/medical-notes-tab/:patientId',
    element: <MedicalNotesTab />,
  },
  // {
  //   path: '/main-settings',
  //   element: <Settings />,
  // },
  // {
  //   path: '/templates',
  //   element: <Navigate to="/main-settings?tab=templates" replace />,
  // },
  {
    path: '/patient/:patientId',
    element: <Patient />,
  },
  {
    path: '/logs/patients/:patientID',
    element: <Logs />,
  },
  {
    path: '/logs/doctors/:doctorID',
    element: <Logs />,
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
]
